import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-number-text-v1',
    templateUrl: './view-number-text-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewNumberTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    ngOnInit(): void {
    }


}
